import React, { PropTypes, Component } from 'react';

import Footer from '../footer/Footer';
import Page from '../../components/layouts/Page';
import Container from '../../components/layouts/Container';

class FooterLayout extends Component {
  render() {
    return (
      <section>

        <Container>
          <Page header footer>{this.props.children}</Page>
        </Container>

        <Footer />
      </section>
    );
  }
}

FooterLayout.propTypes = {
  children: PropTypes.object
};

export default FooterLayout;



// WEBPACK FOOTER //
// ./src/layouts/global/FooterLayout.js